import React, { useEffect } from "react";
import { motion } from "framer-motion";

function BaseModal({ 
  title, 
  children, 
  onClose, 
  footer, 
  maxWidthClass = "max-w-md",
  showCloseButton = true 
}) {
  useEffect(() => {
    // Body scroll lock
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    
    return () => {
      document.body.style.overflow = originalStyle;
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 sm:p-6 outline-none focus:outline-none">
      {/* Backdrop */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-all cursor-default"
      />

      {/* Modal Container */}
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.96 }}
        transition={{ duration: 0.2, ease: "easeOut" }}
        className={`relative w-full ${maxWidthClass} bg-white dark:bg-[#0f1712] rounded-[40px] shadow-2xl shadow-slate-900/20 dark:shadow-none border border-slate-100 dark:border-slate-800/50 overflow-hidden z-10 flex flex-col`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-8 pb-4">
          <div className="min-w-0">
            <h3 className="text-2xl font-black text-slate-900 dark:text-white italic uppercase tracking-tight truncate">
              {title}
            </h3>
          </div>
          {showCloseButton && (
            <button
              type="button"
              onClick={onClose}
              className="h-12 w-12 flex items-center justify-center rounded-2xl text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white transition-all active:scale-95 border border-transparent hover:border-slate-200 dark:hover:border-slate-700"
            >
              <span className="material-symbols-outlined text-[24px]">close</span>
            </button>
          )}
        </div>

        {/* Content */}
        <div className="p-8 pt-0 overflow-y-auto max-h-[70vh] custom-scrollbar">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="p-8 pt-4 flex justify-end gap-4 border-t border-slate-50 dark:border-slate-800/50">
            {footer}
          </div>
        )}
      </motion.div>
    </div>
  );
}

export default BaseModal;


